module.exports = __webpack_public_path__ + "img/treemilkyway_thumb.1b9749bb.jpg";